<template>
	<v-tooltip bottom max-width="480px">
		<template v-slot:activator="{ on }">
			<v-icon color="primary" dark v-on="on" class="ml-3">info</v-icon>
		</template>
		<span>
			{{ text }}
		</span>
	</v-tooltip>
</template>

<script>
export default {
  name: "ContestRankingListViewTooltip",

  props: {
    text: {
      type: String, required: true
    }
  }
};
</script>

<style scoped>

</style>